import axios, { AxiosResponse, InternalAxiosRequestConfig } from "axios";
import { api, vitecompanyserviceurl } from "src/constants/global-const";
import { addAuthHeader } from "src/utils/auth";
import { attachRefreshInterceptor } from "src/utils/axiosRefreshInterceptor";

const eventInstance = axios.create({
  baseURL: api + "/event/logs",
});

const ordersEventInstance = axios.create({
  baseURL: vitecompanyserviceurl + "/event/logs",
});

// Attach 403 refresh-and-retry interceptors
attachRefreshInterceptor(eventInstance);
attachRefreshInterceptor(ordersEventInstance);

eventInstance.interceptors.request.use((config: InternalAxiosRequestConfig) => addAuthHeader(config));

ordersEventInstance.interceptors.request.use((config: InternalAxiosRequestConfig) => addAuthHeader(config));
export const getProductVersioning = async (code: any, typeValue: any, paramType: any, page?: number | string): Promise<AxiosResponse> => {
  if (page) {
    return eventInstance.get(
      `?domain=product&domain_primary_key=${code}` + (paramType && typeValue ? `&${paramType}=${typeValue}` : ``) + `&page=${page}`
    );
  } else return eventInstance.get(`?domain=product&domain_primary_key=${code}` + (paramType && typeValue ? `&${paramType}=${typeValue}` : ``));
};

export const getEmployeeVersioning = async (code: any, typeValue: any, paramType: any, page?: number | string): Promise<AxiosResponse> => {
  if (page) {
    return eventInstance.get(
      `?domain=employee&domain_primary_key=${code}` + (paramType && typeValue ? `&${paramType}=${typeValue}` : ``) + `&page=${page}`
    );
  } else return eventInstance.get(`?domain=employee&domain_primary_key=${code}` + (paramType && typeValue ? `&${paramType}=${typeValue}` : ``));
};

export const getCounterVersioning = async (code: any, typeValue: any, paramType: any, page?: number | string): Promise<AxiosResponse> => {
  if (page) {
    return eventInstance.get(
      `?domain=counter&domain_primary_key=${code}` + (paramType && typeValue ? `&${paramType}=${typeValue}` : ``) + `&page=${page}`
    );
  } else return eventInstance.get(`?domain=counter&domain_primary_key=${code}` + (paramType && typeValue ? `&${paramType}=${typeValue}` : ``));
};

export const getGeographyVersioning = async (code: any, page?: number | string): Promise<AxiosResponse> => {
  if (page) {
    return eventInstance.get(`?domain=state&domain_primary_key=${code}&page=${page}`);
  } else return eventInstance.get(`?domain=state&domain_primary_key=${code}`);
};

export const getDivisionVersioning = async (code: any, typeValue: any, paramType: any, page?: number | string): Promise<AxiosResponse> => {
  if (page) {
    return eventInstance.get(`?domain=division&domain_primary_key=${code}` + (paramType && typeValue ? `&${paramType}=${typeValue}` : ``) + `&page=${page}`);
  } else return eventInstance.get(`?domain=division&domain_primary_key=${code}` + (paramType && typeValue ? `&${paramType}=${typeValue}` : ``));
};

export const getStockistVersioning = async (code: any, page?: number | string): Promise<AxiosResponse> => {
  if (page) {
    return eventInstance.get(`?domain=stockist&domain_primary_key=${code}&page=${page}`);
  } else return eventInstance.get(`?domain=stockist&domain_primary_key=${code}`);
};

export const getInvoiceVersioning = async (invoiceId: any, stockistInvAttachmentId: any, typeValue: any, paramType: any): Promise<AxiosResponse> => {
  if (typeValue?.startsWith("STOCKIST")) {
    return ordersEventInstance.get(`?domain=stockist_attachment&domain_primary_key=${stockistInvAttachmentId}` + (paramType && typeValue ? `&${paramType}=${typeValue}` : `` + `&page=${0}` + `&limit=${100}`));
  } else return ordersEventInstance.get(`?domain=invoice&domain_primary_key=${invoiceId}` + (paramType && typeValue ? `&${paramType}=${typeValue}` : `` + `&page=${0}` + `&limit=${100}`));
};

//M10-11526
export const getOrderVersioning = async (code: any, typeValue: any, paramType: any, company_code?: any, page?: number | string): Promise<AxiosResponse> => {
  const config = {
    headers: {
      company_code: company_code ?? 0,
    },
  };
  if (page) {
    return ordersEventInstance.get(`?domain=order&domain_primary_key=${code}` + (paramType && typeValue ? `&${paramType}=${typeValue}` : ``) + `&page=${page}` + `&limit=${100}`, config);
  } else return ordersEventInstance.get(`?domain=order&domain_primary_key=${code}` + (paramType && typeValue ? `&${paramType}=${typeValue}` : ``) + `&page=${0}` + `&limit=${100}`, config);
};
//M10-11526
//M10-11909
export const getEinvoiceVersioning = async (code: any, company_code?: any, page?: number | string): Promise<AxiosResponse> => {
  const config = {
    headers: {
      company_code: company_code ?? 0,
    },
  };
  if (page) {
    return ordersEventInstance.get(`?domain=stockist_attachment&domain_primary_key=${code}` +  `&page=${page}` + `&limit=${100}`, config);
  } else return ordersEventInstance.get(`?domain=stockist_attachment&domain_primary_key=${code}` + `&page=${0}` + `&limit=${100}`, config);
};
//M10-11909